import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Image } from 'react-native';
import { COMMUNITY_RESOURCE_ICONS } from '@/assets/admin/CommunityResourceIcons';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { MarketplaceListing } from '@/types/residents/marketplaceListing';

const BookmarkFilledIcon = COMMUNITY_RESOURCE_ICONS.bookmarkFilledIcon;
const PropertyPlaceholder = RESIDENTS_SVG_COMPONENTS.PROPERTY_PLACEHOLDER;

interface ListingCardProps {
  listing: MarketplaceListing;
  size: number;
  onPress: () => void;
  showBookmark?: boolean;
}

export const ListingCard: React.FC<ListingCardProps> = ({ 
  listing, 
  size, 
  onPress,
  showBookmark = true,
}) => {
  const firstImageUrl = listing.images?.[0]?.url;
  const hasImage = !!firstImageUrl;

  return (
    <TouchableOpacity 
      style={[styles.container, { width: size, height: size }]}
      onPress={onPress}
      activeOpacity={0.8}
    >
      {hasImage ? (
        <Image
          source={{ uri: firstImageUrl }}
          style={styles.image}
          resizeMode="cover"
        />
      ) : (
        <View style={styles.placeholderContainer}>
          <PropertyPlaceholder width={size * 0.8} height={size * 0.8} />
        </View>
      )}
      
      {/* Bookmark badge for saved items */}
      {showBookmark && listing.isBookmarked && (
        <View style={styles.bookmarkBadge}>
          <BookmarkFilledIcon width={20} height={20} color={MARKETPLACE_COLORS.textPrimary} />
        </View>
      )}
      
      {/* Price badge */}
      <View style={styles.priceBadge}>
        <Text style={styles.priceText}>{listing.price}</Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: 14,
    borderWidth: 0.45,
    borderColor: MARKETPLACE_COLORS.borderGray,
    overflow: 'hidden',
    position: 'relative',
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: 14,
  },
  placeholderContainer: {
    width: '100%',
    height: '100%',
    backgroundColor: MARKETPLACE_COLORS.uploadAreaBackground,
    alignItems: 'center',
    justifyContent: 'center',
  },
  bookmarkBadge: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: 34,
    height: 34,
    borderRadius: 8,
    backgroundColor: MARKETPLACE_COLORS.accentRed,
    alignItems: 'center',
    justifyContent: 'center',
  },
  priceBadge: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    backgroundColor: MARKETPLACE_COLORS.priceBadgeBg,
    borderRadius: 30,
    paddingHorizontal: 9,
    paddingVertical: 6,
  },
  priceText: {
    fontSize: 14,
    fontWeight: '600',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 21,
  },
});

